import type { ImageType } from '@sparklayer-io/spark-dash-ui/components/ui/empty-state/types';
import { Button, Card, EmptyState, Page } from '@ui/themed';
import { SHOPIFY_ADMIN_FALLBACK_URL } from '../constants/shopify';
import { useEnv } from '../context/env-context';
import { useHandlers } from '../context/page-context';
import { getShopifyAppLink } from '../lib/shopify';

type RedirectPageProps = {
  path?: string;
  title: string;
  subtitle?: string;
  action: string;
  imageType?: ImageType;
};

export function RedirectPage({ path = '', title, subtitle, action, imageType }: RedirectPageProps) {
  const { store_id } = useEnv();
  const { navigationHandler } = useHandlers();

  const appLink = store_id ? `${getShopifyAppLink(store_id)}${path}` : SHOPIFY_ADMIN_FALLBACK_URL;

  return (
    <Page>
      <Card>
        <EmptyState compact title={title} subtitle={subtitle} imageType={imageType}>
          <span className="mt-2">
            <Button
              icon="externalLink"
              onClick={() => navigationHandler.navigate(appLink, { absolute: true, newTab: true })}
            >
              {action}
            </Button>
          </span>
        </EmptyState>
      </Card>
    </Page>
  );
}
